const { Component, render } = wp.element;

import { PostBerg_PostItems as PostItems } from './PostItems.js';
import {
  PostBerg_isset as isset,
  PostBerg_Color as Colors,
  PostBerg_GoogleFontLoader as GoogleFontUploader
} from './utils.js';

// Instantiate for every carousel on page
document.addEventListener('DOMContentLoaded', function(event) {
  const posts = document.querySelectorAll('.PostBerg-wrapper');

  for (let i = 0; i < posts.length; i++) {
    let attributes = JSON.parse(posts[i].getAttribute('data-attributes'));
    
    const {
      show_pag,
      button_bg_color,
      button_color,
      button_border_color,
      show_carousel,
      displayDate,
      hideReadMore,
      buttonRadius,
      text_color,
      text_size,
      text_font,
      text_weight,
      main_text_size,
      main_text_font,
      main_text_color,
      main_text_weight,
      button_text_font,
      button_text_size,
      button_text_weight,
      number_of_items,
      orderBy,
      displayType,
      product_columns,
      product_columns_gap,
      iconOptionLeft,
      iconOptionRight,
      show_options,
      paginate_text_color,
      paginate_background_color,
      paginate_active_color,
      paginate_text_size,
      paginate_text_weight,
      category_text_color,
      category_background_color,
      category_active_color,
      category_text_size,
      category_text_weight,
      icon_text_color,
      icon_background_color,
      icon_active_color,
      icon_text_color_hover,
      image_height,
      carousel_gap,
      category_text_color_hover
    } = attributes;


    if (isset(attributes, 'text_font')) {
      GoogleFontUploader(text_font);
    }

    if (isset(attributes, 'main_text_font')) {
      GoogleFontUploader(main_text_font);
    }

    if (isset(attributes, 'button_text_font')) {
      GoogleFontUploader(button_text_font);
    }

    render(
      <PostItems 
          options={{
            displayDate: displayDate,
            number_of_items: number_of_items,
            orderBy: orderBy,
            displayType: displayType,
            product_columns: product_columns,
            product_columns_gap: product_columns_gap,
            text_color: text_color,
            text_size: text_size,
            text_font: text_font,
            text_weight: text_weight,
            main_text_size: main_text_size,
            main_text_font: main_text_font,
            main_text_color: main_text_color,
            main_text_weight: main_text_weight,
            button_text_font: button_text_font,
            button_text_size: button_text_size,
            button_text_weight: button_text_weight,
            button_bg_color: button_bg_color,
            button_color: button_color,
            show_carousel: show_carousel,
            hideReadMore: hideReadMore,
            buttonRadius: buttonRadius,
            button_border_color: button_border_color,
            iconOptionLeft: iconOptionLeft,
            iconOptionRight: iconOptionRight,
            paginate_text_color: paginate_text_color,
            paginate_background_color: paginate_background_color,
            paginate_active_color: paginate_active_color,
            paginate_text_size: paginate_text_size,
            paginate_text_weight: paginate_text_weight,
            category_text_color: category_text_color,
            category_background_color: category_background_color,
            category_active_color: category_active_color,
            category_text_size: category_text_size,
            category_text_weight: category_text_weight,
            icon_text_color: icon_text_color,
            icon_background_color: icon_background_color,
            icon_active_color: icon_active_color,
            icon_text_color_hover: icon_text_color_hover,
            image_height: image_height,
            carousel_gap: carousel_gap,
            category_text_color_hover: category_text_color_hover
          }}
          where="frontend"
        />,
      posts[i]
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/frontend.js